import { BaseHTMLAttributes, renderMaybeFn, useGraphCtx } from '@mi-front/core';
import classNames from 'classnames';
import React from 'react';
import { StreamEl } from '../stream-el';

interface Props extends BaseHTMLAttributes {
  readonly color: string;
  readonly ts?: number;
  readonly offsetX?: number;
  readonly checkOverflow?: boolean;
  readonly thumbnails?: string[];
  readonly showThumbnail?: boolean;
  readonly streamRange?: {
    from: number;
    to: number;
  };
  readonly children?: React.ReactNode | ((p: ChildrenProps) => React.ReactNode);
}

interface ChildrenProps {
  readonly ts?: number;
  readonly height: number;
}

/**
 * Marker is a vertical line in a graph
 */
export function Marker(p: Props) {
  const { height } = useGraphCtx();
  const { ts, color, className, children, offsetX, checkOverflow } = p;

  return (
    <React.Fragment>
      <StreamEl
        fullHeight
        offsetX={offsetX}
        ts={ts}
        checkOverflow={checkOverflow}
        className={classNames(className, 'el-marker')}
      >
        <div
          className={classNames('el-marker__line')}
          style={{
            background: color,
            height,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '2.3px',
            // IMPORTANTE: no remover o causa blur en ClickableArea
            pointerEvents: 'none',
          }}
        />
      </StreamEl>
      {children && renderMaybeFn(children, { ts, height })}
    </React.Fragment>
  );
}

Marker.defaultProps = {
  autoPosition: true,
  showThumbnail: false,
};
